import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-bold text-xl mb-4">RoofingCostsCalculator.com</h3>
            <p className="text-gray-400 text-sm">
              Your trusted source for instant roof cost estimates. Get accurate pricing for residential and commercial roofing projects nationwide.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/" className="hover:text-white transition-colors">Home Calculator</Link></li>
              <li><Link to="/metal-roofing" className="hover:text-white transition-colors">Metal Roofing</Link></li>
              <li><Link to="/commercial-roofing" className="hover:text-white transition-colors">Commercial Roofing</Link></li>
              <li><Link to="/repair-maintenance" className="hover:text-white transition-colors">Repair Estimates</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/virtual-estimate" className="hover:text-white transition-colors">Virtual Estimates</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog & Guides</Link></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#materials" className="hover:text-white transition-colors">Material Comparison</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} RoofingCostsCalculator.com. All rights reserved. Estimates provided for informational purposes only.</p>
        </div>
      </div>
    </footer>
  )
}
